// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2727L","addWidgetButton":"Header_addWidgetButton__3Zosz","dashboardTabs":"Header_dashboardTabs__RLkxf","active":"Header_active__3DETh"};